<template>
  <div v-if="content.urlOrPath" class="NavbarItem">
    <a :href="content.urlOrPath" class="title">{{ content.title }}</a>
  </div>
  <div v-else @mouseover="setHasShade(true)" @mouseout="setHasShade(false)" class="NavbarItem">
    <span class="title">{{ content.title }}</span>
    <NavbarItemDropdown
      v-if="content.groupings || content.entries"
      class="dropdown"
      v-bind="{ content }"
    />
  </div>
</template>

<script>
import NavbarItemDropdown from './NavbarItemDropdown.vue'

export default {
  components: {
    NavbarItemDropdown,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    setHasShade: {
      type: Function,
    },
  },
}
</script>

<style scoped>

.title {
  display: block;
  padding: 0 1.25rem;
  font-size: var(--font-size-2);
  line-height: var(--navbar-height);
  white-space: nowrap;
  transition: color 0.1s;
}

.title:hover {
  color: var(--brand-color);
}

.title:not(:link) {
  cursor: default;
}

.dropdown {
  display: none;
}

.NavbarItem:hover .dropdown {
  display: block;
}
</style>
